/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

export const GenogramCustomConnectionDirectionEnum = Object.freeze({
	NONE: "none",
	DIRECTIONAL: "directional",
})

export const GenogramCustomConnectionPatternEnum = Object.freeze({
	SOLID: "solid",
	DASHED: "dashed",
	DOTTED: "dotted",
	ZIGZAG: "zigzag",
	WAVE: "wave",
	SQUARE_WAVE: "squareWave",
	BROKEN: "broken",
	CHAIN: "chain",
	PULSE: "pulse",
})

export const GenogramCustomConnectionCenterSymbolEnum = Object.freeze({
	NONE: "none",
	SLASH: "slash",
	CROSS: "cross",
	CIRCLE: "circle",
	FILLED_CIRCLE: "filledCircle",
	DIAMOND: "diamond",
	FILLED_DIAMOND: "filledDiamond",
	TRIANGLE: "triangle",
	STAR: "star",
	BOLT: "bolt",
})

export const GenogramCustomConnectionDecorationEnum = Object.freeze({
	NONE: "none",
	PERPENDICULAR_TICKS: "perpendicularTicks",
	CROSS_TICKS: "crossTicks",
	SLASHES: "slashes",
	DOUBLE_TICKS: "doubleTicks",
	DIAMONDS: "diamonds",
	DOTS_OVERLAY: "dotsOverlay",
})
